jQuery(document).ready(function ($) {
  AOS.init({
    disable: 'phone',
    duration: 1000,
  });
});
